<template>
  <side-navigation-container class="faq-list">
    <template #navigation>
      <div class="faq-list__groups">
        <tdx-scroll-navigation
          :items="internalGroups"
          value-field="id"
          :current-value="selectedGroupId"
          @item-clicked="onClickGroupItem"
        >
          <template #text="{ title }">
            {{ title }}
          </template>
        </tdx-scroll-navigation>
      </div>
    </template>
    <template #content>
      <div class="items">
        <faq-item
          v-for="post in internalPosts"
          v-bind="$attrs"
          :key="post.id"
          :post="post"
          class="mt-4--m mt-8"
          v-on="$listeners"
        />
      </div>
    </template>
  </side-navigation-container>
</template>

<script>
export default {
  name: 'FaqList',
  components: {
    SideNavigationContainer: () =>
      import(
        /* webpackChunkName: "InfoPagesComponents" */ '@/components/containers/SideNavigationContainer.vue'
      ),
    TdxScrollNavigation: () =>
      import(
        /* webpackChunkName: "InfoPagesComponents" */ '@/components/navigations/TdxScrollNavigation.vue'
      ),
    FaqItem: () =>
      import(/* webpackMode: "eager" */ '@/components/faq/FaqItem.vue'),
  },
  props: {
    items: {
      // groups with posts
      type: Array,
      default: () => [],
    },

    // for custom usage (groups and posts)
    groups: {
      type: Array,
      default: null,
    },
    posts: {
      type: Array,
      default: null,
    },
    disableSelectionActiveGroup: {
      // Allows not to highlight the selected group in the list
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      selectedGroupId: null,
    }
  },
  computed: {
    internalGroups () {
      if (this.groups) return this.groups
      return this.items.map(group => ({
        id: group.id,
        title: group.name,
      }))
    },
    internalPosts () {
      if (this.posts) return this.posts
      if (!this.selectedGroupId) return []
      const group = this.items.find(group => group.id === this.selectedGroupId)
      if (!group) {
        console.error(
          `FAQ:: group by id ${this.selectedGroupId} not found in list of groups`,
        )
        return []
      }
      return group.posts
    },
  },
  watch: {
    internalGroups: {
      handler (groups) {
        // set the first group as default selected
        if (!groups || !groups.length) return
        if (!this.selectedGroupId) this.selectedGroupId = groups[0].id
      },
      immediate: true,
    },

    '$i18n.locale' () {
      this.$emit('update-items')
    },
  },
  methods: {
    onClickGroupItem ({ item: group }) {
      this.selectedGroupId = group.id
      this.$emit('group-selected', group.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.faq-list {
  &__groups {
    overflow: hidden;

    .tdx-scroll-navigation {
      padding-bottom: toRem(5px);
    }
  }

  .items {
    overflow: hidden;
  }
}
</style>
